<template>
  <section class="bd-b-1 bd-gray-300-brand py-24" v-if='dataTrip'>
    <h2 class="mb-16 heading-4-bd">Trip Overview</h2>
    <div class="description mb-16">
      <Readmore class="text-md-rg" :text="nl2br(dataTrip.overview)" :text-max="isMobile ? 60 : 100" heap="view-full-trip-plan-overview"/>
    </div>
    <template v-if="!isSimplified">
      <div class="flex flex-wrap mb-overflow-y-scroll" >
        <div
          class="bg-gray-50 tc py-4 px-8 br-999 mr-6 item flex items-center white-space mb-6"
          v-for="(item, index) in dataTrip.activity_types" :key="index"
        > 
          <img
            :src="`https://s3-cdn.designerjourneys.com/static/icons/activities/${item.name}.svg`"
            :alt="item.name"
          />
          <label class="text-md-sb mb-text-sm-sb gray-950 db ml-6">{{
            item.name
          }}</label>
        </div>
      </div>
    </template>
  </section>
</template>

<script>
import { inject, ref, } from 'vue'
import Readmore from '~/components/ui/readmore/readmoreHTML'
import { nl2br } from '~/helper'

export default {
  setup() {
    const {isMobile} = useDevice()
    const dataTrip = inject('dataTrip', ref({}))
    const isSimplified = inject('isSimplified', false)
    return {
      nl2br,
      dataTrip,
      isSimplified,
      isMobile,
    }
  },
  components: { Readmore },
}
</script>

<style lang="scss" scoped>
@include scroll-section();
.description {
  a {
    color: #000;
    text-decoration: underline !important;
  }

  p:last-child {
    margin-bottom: 0;
  }
  
  & :deep(.readmore--html) {
      button {
        .underline {
          font-weight: 700;
        }
      }
  }
}

.item {
  flex: 0 0 120px;
  &:last-child {
    margin-right: 0 !important;
  }
  img {
    width: 32px;
    height: auto;
  }
  // svg {
  //   width: 40px;
  //   height: 40px;
  // }
}
</style>
